import { useTitle } from "modules/common";
import React from "react";

export const NoMatch: React.FC = () => {
  useTitle('Stranica nije pronađena - eSavjetnik');
  return <div className="no-match">404 Page not found</div>;
};
